import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { PrivatePageLayout, PageHeader } from "../../components/PrivatePage";
import Ticker from "./Ticker/Ticker";
import Book from "./Book/Book";
import useWebSocket from "react-use-websocket";
import Wallet from "../../components/Wallet/Wallet";
import NewOrderButton from "../../components/NewOrder/NewOrderButton";
import NewOrderModal from "../../components/NewOrder/NewOrderModal";
import ChartPanel from "./ChartPanel";
import SelectSymbol from "../../components/SelectSymbol/SelectSymbol";

import Toast from "../../components/Toast/Toast";

function Dashboard() {
  const history = useHistory();

  const [tickerState, setTickerState] = useState({});

  const [balanceState, setBalanceState] = useState({});

  const [bookState, setBookState] = useState({});

  const [wallet, setWallet] = useState({});

  const [chartSymbol, setChartSymbol] = useState("BTCUSDT");

  const [notification, setNotification] = useState({ type: "", text: "" });

  const { lastJsonMessage } = useWebSocket(process.env.REACT_APP_WS_URL, {
    onOpen: () => {
      console.log(`Connected to App WS`);
    },
    onMessage: () => {
      if (lastJsonMessage) {
        if (lastJsonMessage.ticker) setTickerState(lastJsonMessage.ticker);
        else if (lastJsonMessage.balance) {
          setBalanceState(lastJsonMessage.balance);
        } else if (lastJsonMessage.book) {
          lastJsonMessage.book.forEach((b) => (bookState[b.symbol] = b));
          setBookState(bookState);
        }
      }
    },
    queryParams: { token: localStorage.getItem("token") },
    onError: (event) => {
      console.error(event);
      setNotification({
        type: "warning",
        text: "Market data connection interrupted. Reconnecting…",
      });
    },
    shouldReconnect: (closeEvent) => true,
    reconnectInterval: 3000,
  });

  function onWalletUpdate(walletObj) {
    setWallet(walletObj);
  }

  function onSubmitOrder(order) {
    history.push("/orders/" + order.symbol);
  }

  function onChangeSymbol(event) {
    setChartSymbol(event.target.value);
  }

  return (
    <React.Fragment>
      <PrivatePageLayout width="full">
        <PageHeader
          eyebrow="Overview"
          title="Dashboard"
          subtitle="Live market data, charts, order book, and wallet snapshot."
          actions={(
            <>
              <SelectSymbol onChange={onChangeSymbol} symbol={chartSymbol} />
              <NewOrderButton />
            </>
          )}
        />
        <ChartPanel symbol={chartSymbol} />
        <div className="row">
          <div className="col-12">
            <Ticker data={tickerState} />
          </div>
        </div>
        <div className="w-full grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2">
          <Book data={bookState} />
          <Wallet data={balanceState} onUpdate={onWalletUpdate} />
        </div>
      </PrivatePageLayout>
      <NewOrderModal wallet={wallet} onSubmit={onSubmitOrder} />
      <Toast type={notification.type} text={notification.text} />
    </React.Fragment>
  );
}

export default Dashboard;
